<template>
    <!-- Edit / Preview, centered on the full width above the document; the Preview note sits under it -->
    <div class="ep-mode">
        <div class="ep-seg" role="tablist" aria-label="Edit or preview">
            <button type="button" role="tab" :aria-selected="!preview" :class="{ on: !preview }" @click="$emit('edit')">
                <svg viewBox="0 0 24 24"><path d="M4 20h4L18.5 9.5a2.83 2.83 0 0 0-4-4L4 16v4M13.5 6.5l4 4" /></svg>Edit
            </button>
            <button type="button" role="tab" :aria-selected="preview" :class="{ on: preview }" @click="$emit('preview')">
                <svg viewBox="0 0 24 24"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></svg>Preview
            </button>
        </div>
        <div v-if="preview" class="ep-prevnote">
            <svg viewBox="0 0 24 24"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></svg>
            This is what your team will see after you save.<template v-if="changedCount"> Changed {{ changedLabel }} are marked.</template>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'EditorModeToggle',
    // changedLabel: what the page calls its parts, e.g. 'steps', 'stages'
    props: [ 'preview', 'changedCount', 'changedLabel' ],
    emits: [ 'edit', 'preview' ]
});
</script>
